import { render, staticRenderFns } from "./EpisodesList.vue?vue&type=template&id=298fe8a6&scoped=true"
import script from "./EpisodesList.vue?vue&type=script&lang=js"
export * from "./EpisodesList.vue?vue&type=script&lang=js"
import style0 from "./EpisodesList.vue?vue&type=style&index=0&id=298fe8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fe8a6",
  null
  
)

export default component.exports